export interface UserType {
  created: string,
  updated: string,
  deleted: string,
  customerId: string,
  name: string,
  walletBalance: string,
  walletNumber: string,
  status: string,
  rewardBalance: string,
  mobileNumber: number,
}

/**
 * @param  {user.created||null} created
 * @param  {user.updated||null} updated
 * @param  {user.deleted||null} deleted
 * @param  {user.customerId||null} customerId
 * @param  {user.name||null} name
 * @param  {user.walletBalance||null} walletBalance
 * @param  {user.walletNumber||null} walletNumber
 * @param  {user.status||null} status
 * @param  {user.rewardBalance||null} rewardBalance
 * @param  {} }
 * Returning undefined inside react render function will give error,
 */
export const userTransformer = (data: UserType) => {
    if (!data) {
      return {};
    }
    return {
      created: data.created || null,
      updated: data.updated || null,
      deleted: data.deleted || null,
      customerId: data.customerId || null,
      name: data.name || null,
      walletBalance: data.walletBalance || null,
      walletNumber: data.walletNumber || null,
      status: data.status || null,
      rewardBalance: data.rewardBalance || null,
      mobileNumber: data.mobileNumber || null,
    };
  };
